<template>
  <item-table></item-table>
</template>
<script>

import Itemtable from '@/components/Itemtable'

// how many rows to display per page by default
export default {
  components: {
    'item-table': Itemtable
  },
  name: 'Awards'
}
</script>
